module.exports = __webpack_public_path__ + "static/media/TeamBanner.d8a4e04d.jpg";